import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';
const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/',
        redirect: '/booking',
        component: () => import('../layouts/MainLayout.vue'),
        meta: { requiresAuth: true },
        children: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: () => import('../views/Dashboard.vue'),
                meta: { requiresAuth: true, title: 'Dashboard' }
            },
            {
                path: '/booking',
                name: 'Booking',
                component: () => import('../views/Booking.vue'),
                meta: { requiresAuth: true, title: 'New Booking' }
            },
            {
                path: '/bookings',
                name: 'Bookings',
                component: () => import('../views/Bookings.vue'),
                meta: { requiresAuth: true, title: 'All Bookings' }
            },
            {
                path: '/customers',
                name: 'Customers',
                component: () => import('../views/Customers.vue'),
                meta: { requiresAuth: true, title: 'Customers' }
            },
            {
                path: '/reports',
                name: 'Reports',
                component: () => import('../views/Reports.vue'),
                meta: { requiresAuth: true, title: 'Reports' }
            },
            {
                path: '/settings',
                name: 'Settings',
                component: () => import('../views/Settings.vue'),
                meta: { requiresAuth: true, title: 'Settings' }
            },
            {
                path: '/profile',
                name: 'Profile',
                component: () => import('../views/Profile.vue'),
                meta: { requiresAuth: true, title: 'Profile' }
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('../views/NotFound.vue')
    }
];
const router = createRouter({
    history: createWebHistory(),
    routes
});
// Navigation guard for authentication
router.beforeEach(async (to, _, next) => {
    const authStore = useAuthStore();
    const requiresAuth = to.meta.requiresAuth !== false;
    if (requiresAuth) {
        // Check if user has a token in localStorage
        const token = localStorage.getItem('token');
        if (!token) {
            // No token found, redirect to login
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
            return;
        }
        // For now, skip the server verification to allow navigation
        // You can re-enable this once the verify endpoint is working
        const skipVerify = true; // Set to false to enable server verification
        if (skipVerify) {
            next();
            return;
        }
        // Verify token is still valid with the server
        try {
            const isValid = await authStore.checkAuth();
            if (isValid) {
                next();
            }
            else {
                // Token is invalid, redirect to login
                next({
                    path: '/login',
                    query: { redirect: to.fullPath }
                });
            }
        }
        catch (error) {
            // Error checking auth, redirect to login
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        }
    }
    else {
        // Page doesn't require auth
        if (to.path === '/login' && authStore.isAuthenticated) {
            // Already logged in, redirect to booking page
            next('/booking');
        }
        else {
            next();
        }
    }
});
export default router;
